// AR
export const listingRatesManager = {
  header: {
    eyebrow: "الأسعار المشتقة",
    title: "أسعار الإعلان",
    subtitle:
      "مركزية إعداد الأسعار وطبّقها على الوحدات التي تحتاجها، حتى عبر عدة إعلانات، دون تكرار العمل واحدة تلو الأخرى.",
    newRate: "سعر جديد",
  },
  baseInfo: {
    title: "الأسعار الأساسية لكل ليلة",
    perNight: "/ ليلة",
    hint: "تُحتسب الأسعار المشتقة كتعديل (نسبة مئوية أو مبلغ ثابت) على هذه الأسعار الأساسية.",
  },
  states: {
    loading: "جارٍ تحميل أسعار الإعلان...",
    emptyTitle: "لا توجد أسعار مشتقة بعد",
    emptyText:
      "أنشئ سعرًا مشتقًا لمزامنة الأسعار مع قنوات مثل Booking.com أو Airbnb.",
    createFirst: "إنشاء أول سعر",
  },
  group: {
    unitsCount: "{count} وحدة | {count} وحدات",
    manageTitle: "إدارة مجموعة الأسعار",
    manage: "إدارة",
    modalTitle: "إدارة السعر",
    apply: "تطبيق",
    appliedUnits: "الوحدات المطبَّق عليها",
    removeSyncedWarn:
      "هذا السعر متصل بالقناة. إزالته ستحذفه من القناة أيضًا.",
    removeConfirm: "هل تؤكد إزالة هذا السعر من هذه الوحدة؟",
    removing: "جارٍ الإزالة...",
    confirmRemove: "نعم، أزِل",
    removeTitle: "إزالة من هذه الوحدة",
    remove: "إزالة",
  },
  chips: {
    connect: "Connect",
    paused: "مُوقَف",
    syncedTitle: "متزامن مع القناة",
  },
  actions: {
    editTitle: "تعديل السعر",
    duplicateTitle: "تكرار أو نسخ",
    pause: "إيقاف البيع",
    resume: "استئناف البيع",
    deleteTitle: "حذف",
  },
  modal: {
    createTitle: "سعر مشتق جديد",
    editTitle: "تعديل السعر",
    importPlaceholder: "النسخ من سعر موجود…",
    namePlaceholder: "اسم السعر",
    percentage: "% نسبة مئوية",
    fixed: "قيمة ثابتة",
    derivationHint: "القيمة السالبة تخفض السعر الأساسي، والموجبة ترفعه.",
    searchPlaceholder: "بحث…",
    unitsCounter: "{selected} / {total} وحدة",
    selectAll: "تحديد الكل",
    deselectAll: "إلغاء تحديد الكل",
    loadingUnits: "جارٍ التحميل…",
    currentBadge: "الحالي",
    unitsWithRate: "{count} وحدة بسعر | {count} وحدات بسعر",
    noBaseRate: "لا يوجد سعر أساسي",
    noResults: 'لا نتائج لـ "{query}"',
    create: "إنشاء السعر",
    creating: "جارٍ الإنشاء…",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
  },
  delete: {
    title: "حذف السعر المشتق",
    subtitle: "أكِّد الاسم لتجنب حذف سعر عن طريق الخطأ.",
    confirmCopy: "اكتب اسم السعر للتأكيد:",
    deleting: "جارٍ الحذف...",
  },
  types: {
    apartment: "شقة",
    house: "منزل",
    villa: "فيلا",
    hotel: "فندق",
    room: "غرفة",
    studio: "استوديو",
    camping: "تخييم",
    default: "مكان إقامة",
  },
  misc: {
    noName: "بدون اسم",
    unitFallback: "الوحدة #{id}",
    basePrefix: "الأساس:",
  },
  common: {
    cancel: "إلغاء",
    delete: "حذف",
    close: "إغلاق",
  },
  toasts: {
    loadError: "تعذّر تحميل أسعار الإعلان",
    loadListingsError: "تعذّر تحميل الإعلانات",
    selectUnit: "اختر وحدة واحدة على الأقل لها سعر أساسي.",
    created: "تم إنشاء السعر بنجاح",
    createdPartial: "تعذّر إنشاء بعض الأسعار",
    createError: "تعذّر إنشاء السعر",
    updated: "تم تحديث السعر بنجاح",
    updateError: "تعذّر تحديث السعر",
    updateErrorGeneric: "خطأ أثناء تحديث السعر",
    deleted: "تم حذف السعر",
    deleteError: "خطأ أثناء الحذف",
    groupUpdated:
      "تم تحديث السعر في {count} وحدة | تم تحديث السعر في {count} وحدات",
    groupUpdatedPartial: "{success} محدَّثة، {error} بها خطأ",
    removedFromUnit: "تمت إزالة السعر من هذه الوحدة",
    removeError: "تعذّر إزالة السعر",
    removeErrorGeneric: "خطأ أثناء إزالة السعر",
    toggleError: "تعذّر تغيير حالة السعر",
  },
};
